/**
 * @generated SignedSource<<994f7b8f96d2cfea26fc20d7e3f048cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CopyAccountLoaderSubscription$variables = Record<PropertyKey, never>;
export type CopyAccountLoaderSubscription$data = {
  readonly current_account: {
    readonly copy_started_at: number | null | undefined;
    readonly copy_status: string | null | undefined;
    readonly id: number;
  } | null | undefined;
};
export type CopyAccountLoaderSubscription = {
  response: CopyAccountLoaderSubscription$data;
  variables: CopyAccountLoaderSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "accounts",
    "kind": "LinkedField",
    "name": "current_account",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "copy_status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "copy_started_at",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyAccountLoaderSubscription",
    "selections": (v0/*: any*/),
    "type": "subscription_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CopyAccountLoaderSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "488df1b0f70be5eaf3f2648f04f636ff",
    "id": null,
    "metadata": {},
    "name": "CopyAccountLoaderSubscription",
    "operationKind": "subscription",
    "text": "subscription CopyAccountLoaderSubscription {\n  current_account {\n    id\n    copy_status\n    copy_started_at\n  }\n}\n"
  }
};
})();

(node as any).hash = "23ce022713b353fad51ffdc3417ce3ef";

export default node;
